<template>
  <ReactiveDynamicForm
    :schema="schema"
    @onFormUpdate="updateFormValue"
  ></ReactiveDynamicForm>
</template>

<script>
export default {
  name: 'DesignPage',
  components: {
    ReactiveDynamicForm: () => import('../lib/rd-forms/ReactiveDynamicForm')
  },
  data() {
    return {
      schema: {
        txt1: {
          type: 'text',
          label: 'lbl1'
        },
        nr1: {
          type: 'number',
          label: 'Integer'
        },
        dec1: {
          type: 'number',
          label: 'Decimal',
          numberType: 'decimal'
        }
      },
      formValue: {}
    }
  },
  methods: {
    updateFormValue: function(newVal, key) {
      this.formValue[key] = newVal
    }
  }
}
</script>
